export default __webpack_public_path__ + "static/media/card-delete-icon.84039d2e.svg";